import i18n from "lib/i18n";
import moment from "moment";
import { delay, template } from "lodash";
import { View } from "backbone";
import CalendarView from "views/calendar_view";
import CustomDateRangeConfirmationView from "views/custom_date_range_confirmation_view";
/* eslint-disable
    consistent-return,
    func-names,
    no-multi-assign,
    no-multi-str,
    no-return-assign,
    no-shadow,
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CalendarDateRangePickerView;

// A nice, simple calendar date picker.
// Has two CalendarView objects for start and end dates
export default CalendarDateRangePickerView = (function () {
  CalendarDateRangePickerView = class CalendarDateRangePickerView extends View {
    static initClass() {
      this.prototype.className = "calendars";
      this.prototype.events = {
        "click .range": "makeSelection",
        "click .start-date-selected": "openStartDateCalendar",
        "click .end-date-selected": "openEndDateCalendar",
      };

      this.prototype.startOfTime =
        "2011-03-25";

      this.prototype.template = template("\
<div class=\"calendar-container\"></div>\
");
    }

    initialize(options) {
      this.startDate = options.startDate;
      this.endDate = options.endDate;

      return this.render();
    }

    render() {
      this.$el.html(this.template);
      this.calendarsEl = this.$el.find(".calendar-container");

      this.startDateEl = this.$el.find(".start-date");
      this.startCalendar = new CalendarView({
        startDate: moment(this.startDate).format("YYYY-MM-DD"),
        displayDate: moment(this.startDate),
        endDate: moment(this.endDate).format("YYYY-MM-DD"),
        rangeStart: this.startOfTime,
        rangeEnd: moment(),
        message: i18n.t("calendar.label.select_start_date"),
      });
      this.startCalendar.$el.appendTo(this.calendarsEl);

      this.startCalendar.bind("update_date", (date) => {
        delay(() => this.displayEndDateCalendar(), 500);

        this.startCalendar.updateStartDate(date);
        this.endCalendar.updateRangeStartDate(date);
        this.endCalendar.updateStartDate(date);
        this.confirmationView.setStartDate(date);
        return this.setStartDate(date);
      });

      this.endDateEl = this.$el.find(".end-date");
      this.endCalendar = new CalendarView({
        startDate: moment(this.startDate).format("YYYY-MM-DD"),
        displayDate: this.endDate,
        endDate: moment(this.endDate).format("YYYY-MM-DD"),
        rangeStart: moment(this.startDate),
        rangeEnd: moment(),
        message: i18n.t("calendar.label.select_end_date"),
      });
      this.endCalendar.$el.appendTo(this.calendarsEl);

      this.endCalendar.bind("update_date", (date) => {
        delay(() => this.displayConfirmationView(), 500);

        this.endCalendar.updateEndDate(date);
        this.confirmationView.setEndDate(date);
        return this.setEndDate(date);
      });

      this.confirmationView = new CustomDateRangeConfirmationView({
        startDate: moment(this.startDate).format("MMMM Do YYYY"),
        endDate: moment(this.endDate).format("MMMM Do YYYY"),
      });
      this.confirmationView.$el.appendTo(this.calendarsEl);

      // sad duplication, needs refactoring
      this.confirmationView.on("done", () => {
        const startDate = moment(this.startDate).format("YYYY-MM-DD");
        const endDate = moment(this.endDate).format("YYYY-MM-DD");
        return this.trigger("update_date_range", startDate, endDate);
      });

      return this.confirmationView.on("cancel", () => this.trigger("cancel_date_pick"));
    }

    setStartDate(date) {
      if (date !== this.startDate) {
        this.dirty = true;
        return this.startDate = date;
      }
    }

    setEndDate(date) {
      if (date !== this.endDate) {
        this.dirty = true;
        return this.endDate = date;
      }
    }

    openStartDateCalendar(event) {
      event.preventDefault();
      return this.displayStartDateCalendar();
    }

    displayStartDateCalendar() {
      return this.$el.addClass("open-start").removeClass("step-2").removeClass("step-3");
    }

    openEndDateCalendar(event) {
      event.preventDefault();
      return this.displayEndDateCalendar();
    }

    displayEndDateCalendar() {
      return this.$el.removeClass("open-start").addClass("step-2").removeClass("step-3");
    }

    displayConfirmationView() {
      return this.$el.removeClass("open-start").removeClass("step-2").addClass("step-3");
    }

    makeSelection(event) {
      event.preventDefault();
      const startDate = moment(this.startDate).format("YYYY-MM-DD");
      const endDate = moment(this.endDate).format("YYYY-MM-DD");
      return this.trigger("update_date_range", startDate, endDate);
    }
  };
  CalendarDateRangePickerView.initClass();
  return CalendarDateRangePickerView;
}());
